<div
  class="share-screen-wrapper"
  [ngClass]="{
    'size-medium': !isFullScreen,
    'size-full-screen': isFullScreen,
    'drawer-open': isGalleryDrawerOpen,
    'is-sharing': isSharingScreen,
  }"
  [ngStyle]="{ background: presentationV3 && 'none' }"
>
  <div
    class="video-wrapper"
    #videoWrapper
    [ngClass]="{ 'zoom-content': isZoomedIn, 'fullscreen-mobile-wrapper': isFullScreenMobile }"
  >
    @if (isMobile) {
      @if (isFullScreenMobile) {
        <a class="close-fullscreen-mobile-button" (click)="handleFullscreenChange()">
          <mat-icon>close</mat-icon>
        </a>
      } @else {
        <a class="fullscreen-mobile-button" (click)="handleFullscreenChange()"> <mat-icon>fullscreen</mat-icon> </a>
      }
    } @else {
      @if (presentationV3) {
        <a
          class="maximize-screen-share"
          (click)="toggleFullScreen()"
          [matTooltip]="isFullScreen ? 'Minimize' : 'Maximize'"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="{{ isFullScreen ? 'MINIMIZE' : 'MAXIMIZE' }}"></mat-icon>
        </a>
      } @else {
        @if (isPresentersDrawerOpen) {
          <a
            class="button-full-screen"
            (click)="toggleFullScreen()"
            [matTooltip]="isFullScreen ? 'Minimize' : 'Maximize'"
            matTooltipPosition="above"
          >
            <mat-icon svgIcon="{{ isFullScreen ? 'MINIMIZE' : 'MAXIMIZE' }}"></mat-icon>
          </a>
        }
      }
    }

    <div class="screen-share-video-fullscreen" [ngClass]="{ 'fullscreen-mobile-video-wrapper': isFullScreenMobile }">
      <video
        #videoElement
        id="screen-share-video"
        autoplay
        playsinline
        [ngStyle]="screenShareZoom ? videoStyles : {}"
        [ngClass]="{ 'fullscreen-mobile': isFullScreenMobile }"
        (mousedown)="startDrag($event)"
        (mousemove)="dragScreenShare($event)"
        (mouseup)="endDrag($event)"
        (mouseleave)="leaveDraggableArea()"
      ></video>
    </div>

    @if (screenShareZoom) {
      <div class="zoom-in-controls-wrapper" [ngClass]="{ 'fullscreen-zoom-in-controls': isFullScreenMobile }">
        <button (click)="controlZoom('in')" [matTooltip]="'Zoom In'" matTooltipPosition="above">
          <mat-icon class="button-icon">add</mat-icon>
        </button>
        <button (click)="controlZoom('out')" [matTooltip]="'Zoom Out'" matTooltipPosition="above">
          <mat-icon class="button-icon">remove</mat-icon>
        </button>
        <button (click)="controlZoom('reset')" [matTooltip]="'Reset to Default View'" matTooltipPosition="above">
          <mat-icon class="button-icon-svg" svgIcon="RESTORE_SCREENSHARE"></mat-icon>
        </button>
      </div>
    }
    @if (popOutVideo) {
      <div [ngClass]="{ 'screenshare-popout': !isScreenPopout, 'screenshare-in-popout': isScreenPopout }">
        <app-presentation-popout-button
          [videoElementToPopOut]="videoElement"
          [mode]="'SCREENSHARE'"
        ></app-presentation-popout-button>
      </div>
    }
    <div class="loading-container" [ngStyle]="{ background: presentationV3 && 'none' }">
      <app-loading class="loading"></app-loading>
    </div>
  </div>
</div>
